/* eslint-disable max-len */
import { StatusType } from '@1po/1po-bff-fe-spec/generated/backoffice/information/request/GetInformations';
import { PromotionReferencesFileUploadResponse } from '@1po/1po-bff-fe-spec/generated/backoffice/promotion/response/PromotionReferencesFileUploadResponse';
import { UploadReferencesFileResponse } from '@1po/1po-bff-fe-spec/generated/basket/response/UploadReferencesFileResponse';
import { Provider } from '@1po/1po-bff-fe-spec/generated/catalog/category/response/SearchVehicleIAMPartCategoryTreeResponse';
import { GetClaimAttachmentDownloadUrlResponse } from '@1po/1po-bff-fe-spec/generated/claim/response/GetClaimAttachmentDownloadUrlResponse';
import { BusinessError } from '@1po/1po-bff-fe-spec/generated/error/BusinessError';
import { call, put, takeEvery } from '@redux-saga/core/effects';
import { SagaIterator } from 'redux-saga';
import { RootState } from 'app/AppStore';
import {
  API_CALL_ERROR,
  CONTENT_LIMIT_ERROR,
  EMPTY_FILE_ERROR,
  FILE,
  FILE_STRUCTURE_ERROR,
  NO_FILE,
  REPLACING_FILE,
  SAME_FILE,
  SAME_FILE_ERROR,
  TECHNICAL_ERROR,
} from 'components/FileUpload/paramsByState';
import {
  setBamCommercialFamilyCodesFileModalStatus,
  setBamCommercialFamilyCodesFileUploadStatus,
} from 'domains/bamCommercialFamilyCodes/BamCommercialFamilyCodes.store';
import {
  setBasketIdStatus,
  setFileReferencesUploadStatusErrorRows,
  setFileReferencesUploadStatusModalStatus,
} from 'domains/basket/Basket.store';
import {
  getLastSearchedVehicleKey,
  getSearchStatus,
  setExplodedTreeNoDataStatus,
  setFulltextAutocompleteNoData,
  setIAMFulltextEquivalentNoData,
  setIAMLaborTimeNoDataStatus,
  setIAMRepairMethodsNoDataStatus,
  setIAMRepairMethodsTreeNoDataStatus,
  setIAMVehicleBrandsNoDataStatus,
  setIAMVehicleModelsNoDataStatus,
  setIAMVehicleVersionsNoDataStatus,
  setLevels3DetailNoDataStatus,
  setMaintenancePlanStatus,
  setMarketingReferences,
  setNodeIAMReferencesStatus,
  setPlateReferenceNoDataStatus,
  setSearchStatus,
  setUniversalProductsNoDataState,
  setUniversalProductsTree,
  resetUniversalProductsPaged,
  setVehicleBrandsNoDataStatus,
  setVehicleDetail,
  setVehicleEnginesNoDataStatus,
  setVehicleTechnicalCriteriaNoDataStatus,
  setVehicleTechnicalDataDetailsNoDataStatus,
  setVehicleTechnicalDataTreeNoDataStatus,
} from 'domains/catalog/Catalog.store';
import { setCentralSettingsStatus } from 'domains/centralSettings/CentralSettings.store';
import {
  getCrossSellingFileUploadStatus,
  setCrossSellingFileModalStatus,
  setCrossSellingFileUploadStatus,
  setCrossSellingSearchFileStatus,
} from 'domains/crossSelling/CrossSelling.store';
import { setPossibleBuyersForSellerToDelegateNoData, setPossibleSellersToDelegateNoData } from 'domains/delegation';
import {
  setDiscontinuedReferencesFileModalStatus,
  setDiscontinuedReferencesFileUploadStatus,
} from 'domains/discontinuedReferences/DiscontinuedReferences.store';
import { setOperationsDetailsStatus, setOperationsStatus } from 'domains/easyBasket/EasyBasket.store';
import {
  getElectronicPartsRepairFileUploadStatus,
  setElectronicPartsRepairFileIsModalOpen,
  setElectronicPartsRepairFileModalStatus,
  setElectronicPartsRepairFileUploadStatus,
  setElectronicPartsRepairSearchStatus,
} from 'domains/electronicPartsRepair/ElectronicPartsRepair.store';
import { setEmailToAssistanceDataStatus, setReturnRequestStatus } from 'domains/email/Email.store';
import * as actions from 'domains/errors/Errors.store';
import { BE_NOT_FOUND } from 'domains/errors/Errors.types';
import {
  setB2BEstimateReferencesPriceNoDataStatus,
  setB2BEstimateReferencesStockNoDataStatus,
  setBundleFulltextAutocompleteNoData,
  setEasyBasketEstimateCreationStatus,
  setEstimateDataStatus,
  setEstimateHistorySearchStatus,
  setSettings,
} from 'domains/estimate/Estimate.store';
import { setGarageNoDataStatus } from 'domains/garage/Garage.store';
import {
  setInformationBanners,
  setInformationStatus,
  setLoadedInformationsSearchStatus,
} from 'domains/information/Information.store';
import { setGenericPartLaborTimesSearchStatus, setLaborTimesSearchStatus } from 'domains/laborTime/LaborTime.store';
import {
  setRepairMethodDetailsStatus,
  setServiceOperationsStatus,
  setServiceProposalOperationsStatus,
  setServiceProposalsStatus,
} from 'domains/maintenancePlan/MaintenancePlan.store';
import { setMaintenanceValuesStatus } from 'domains/maintenanceValues/MaintenanceValues.store';
import { setBundlesStatus, setMyStoreTiresSearchStatus, setReferencesStatus } from 'domains/myStore/MyStore.store';
import {
  clearOrderClaimAttachmentDownloading,
  clearClaimVehicleInfo,
  resetMyClientsOrders,
  setAscOrdersStatus,
  setExternalOrdersNoDataStatus,
  setInProgressOrderSearchStatus,
  setInProgressOrdersNotFound,
  setLoadedClaimsSearchStatus,
  setMyClientsOrderDetailStatus,
  setOrderClaimStatus,
  setExadisReturnList,
  setExadisReturnListAddItemStatus,
  setVrnSearchLoading,
} from 'domains/order/Order.store';
import { setCreateOrderListSearchStatus, setOrderListFileModalStatus } from 'domains/orderList/OrderList.store';
import { setPictureNoDataStatus } from 'domains/pictures/Pictures.store';
import {
  removeUploadedReferencesRows,
  removeUploadedTargetedAudienceRows,
  setCurrentPromotionsDataStatus,
  setFullPromotionState,
  setPromotionBannersStatus,
  setPromotionDetailDataStatus,
  setPublishedPromotionStatus,
} from 'domains/promotion/Promotion.store';
import {
  resetMyNetworkClients,
  setClientConfig,
  setMyNetworkClientsSubmitting,
} from 'domains/r1Network/R1Network.store';
import {
  setDHSingleReferenceStatus,
  setDiscontinuedReferenceSearchStatus,
  setDmsReferencesStocksNoDataStatus,
  setPlatesForReferenceSearchStatus,
  setReference3dModelSearchStatus,
  setReferenceApplicabilitiesNoDataStatus,
  setReferencesPriceNoDataStatusV2,
  setReferencesRepairPriceNoDataStatus,
  setReferencesStocksNoDataStatus,
  setResolveCrossSellingReferencesStatus,
  setReuseAvailabilitiesNoDataStatus,
  setReuseStockNoDataStatus,
} from 'domains/references';
import {
  setIAMTiresNoDataStatus,
  setMprValidationStatus,
  setTireBrandCategoriesSearchStatus,
  setTireSearchStatus,
  setVehicleTiresStatus,
} from 'domains/tires/Tire.store';
import {
  DmsErrorType,
  setAvailableDMSServicesStatus,
  setDMSErrors,
  setUserSellersToChoose,
  setVehicleSearchHistoryStatus,
} from 'domains/user';
import { WsResponse } from 'domains/webSockets/WebSocket.types';
import { notifyTop } from 'UI/Notification/notification';
import { ERROR, FOUND, getData, NOT_FOUND, sagaGuard } from 'utils';
import { select } from 'utils/domainStore';
import { AppTranslation } from 'utils/i18n';
import {
  getAllDocumentsId,
  getAllMultiPlateIds,
  getAllOperationIds,
  getAllReferences,
  getDMSErrorCode,
  getDMSErrorMessage,
  getDMSErrorType,
  getFirstBrand,
  getFirstBuyer,
  getFirstEstimateId,
  getFirstGarageId,
  getFirstIAMVehicleCode,
  getFirstInformationId,
  getFirstModel,
  getFirstModelType,
  getFirstNodeId,
  getFirstOrderNumber,
  getFirstPictureKey,
  getFirstPlateId,
  getFirstPromotionId,
  getFirstProvider,
  getFirstReference,
  getFirstSearchDescription,
  getFirstSearchId,
  getFirstSearchText,
  getFirstSeller,
  getFirstSellerId,
  getFirstVehicleKey,
  getFirstVIN,
  getGenericPart,
  getInformationsStatus,
  getLaborTimeId,
  getLaborTimeIds,
  getSecondDMSErrorCode,
  getSecondDMSErrorMessage,
  getSecondDMSErrorType,
  getTireSearchStatus,
} from './Errors.mapper';

const getStatus = (payload: BusinessError) => (payload.errorType === BE_NOT_FOUND ? NOT_FOUND : ERROR);

export function* fetchSearchVehicleErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  if (action.payload?.requestId) {
    yield put(
      setVehicleDetail({
        requestId: action.payload.requestId,
        vehicle: undefined,
        status: getStatus(action.payload),
      }),
    );
  }
}

export function* fetchVehicleInfoByVrnErrorSaga(): SagaIterator {
  yield put(clearClaimVehicleInfo());
  yield put(setVrnSearchLoading(false));
  yield call(
    notifyTop,
    'error',
    AppTranslation.t('catalog.vehicle.search_vehicle_info.error.vrn', 'Cannot find vehicle'),
    AppTranslation.t(
      'catalog.vehicle.search_vehicle_info.error.vrn.description',
      'No vehicle was found for the given VRN.',
    ),
  );
}

export function* fetchPlateReferencesErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const plateId = getFirstPlateId(action);
  const vehicleKey = getFirstVehicleKey(action);
  if (plateId && vehicleKey) {
    yield put(
      setPlateReferenceNoDataStatus({
        vehicleKey,
        plateId,
        status: getStatus(action.payload),
      }),
    );
  }
}

export function* fetchMarketingReferencesErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVehicleKey(action);
  const nodeId = getFirstNodeId(action);
  if (vehicleKey && nodeId) {
    yield put(
      setMarketingReferences({
        vehicleKey,
        nodeId,
        incomingReferences: [],
      }),
    );
  }
}

export function* fetchReferencesStocksErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const references = getAllReferences(action);
  if (references) {
    yield put(setReferencesStocksNoDataStatus({ references, status: getStatus(action.payload) }));
  }
}

export function* fetchDmsReferencesStocksErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const references = getAllReferences(action);
  if (references) {
    yield put(setDmsReferencesStocksNoDataStatus({ references, status: getStatus(action.payload) }));
  }
}

export function* fetchReferencesStocksTimeoutErrorSaga(
  action: WsResponse<{ references: string[] | undefined }>,
): SagaIterator {
  if (action.payload.references) {
    yield put(setReferencesStocksNoDataStatus({ references: action.payload.references, status: ERROR }));
    yield put(setDmsReferencesStocksNoDataStatus({ references: action.payload.references, status: undefined }));
  }
}

export function* fetchReferencesPriceErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const references = getAllReferences(action);
  if (references) {
    yield put(
      setReferencesPriceNoDataStatusV2({
        referenceNumbers: references,
        status: getStatus(action.payload),
      }),
    );
  }
}

export function* fetchLaborTimeIdsByGenericPartErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const genericPart = getGenericPart(action);
  const vehicleKey = getFirstVehicleKey(action);

  if (vehicleKey && genericPart) {
    yield put(
      setGenericPartLaborTimesSearchStatus({
        vehicleKey,
        genericPart,
        status: NOT_FOUND,
      }),
    );
  }
}

export function* fetchReferencesRepairPriceErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const references = getAllReferences(action);
  if (references) {
    yield put(
      setReferencesRepairPriceNoDataStatus({
        referenceNumbers: references,
        status: getStatus(action.payload),
      }),
    );
  }
}

export function* fetchBasketErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  if (action.payload) {
    const { errorType } = action.payload;
    if (errorType !== BE_NOT_FOUND) {
      yield call(notifyTop, 'error', 'Basket loading was not successful');
    }
    yield put(setBasketIdStatus(getStatus(action.payload)));
  }
}

export function* fetchAddEstimateKnownLaborTimeErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const laborTimeId = getLaborTimeId(action);
  if (laborTimeId) {
    yield call(
      notifyTop,
      'error',
      AppTranslation.t('errors.estimate_settings_not_found', 'Estimate settings does not exist'),
      AppTranslation.t(
        'errors.estimate_settings_not_found.missing_labor_time_technicity',
        'Please fill in labor time technicity in the settings tab',
      ),
    );
    return;
  }

  yield call(notifyTop, 'error', AppTranslation.t('errors.unknown_code', 'Unknown code'), null);
}

export function* fetchUploadFileReferences99ReferencesErrorSaga(
  action: WsResponse<UploadReferencesFileResponse>,
): SagaIterator {
  const { errorRows } = action.payload;
  yield put(setFileReferencesUploadStatusErrorRows(errorRows));
  yield put(setFileReferencesUploadStatusModalStatus(CONTENT_LIMIT_ERROR));
}

export function* fetchUploadFileReferencesTechnicalErrorSaga(
  action: WsResponse<UploadReferencesFileResponse>,
): SagaIterator {
  const { errorRows } = action.payload;
  yield put(setFileReferencesUploadStatusErrorRows(errorRows));
  yield put(setFileReferencesUploadStatusModalStatus(TECHNICAL_ERROR));
}

export function* fetchUploadFileReferencesApiCallErrorSaga(
  action: WsResponse<UploadReferencesFileResponse>,
): SagaIterator {
  const { errorRows } = action.payload;
  yield put(setFileReferencesUploadStatusErrorRows(errorRows));
  yield put(setFileReferencesUploadStatusModalStatus(API_CALL_ERROR));
}

export function* fetchDealerOrderListSaga(action: WsResponse<BusinessError>): SagaIterator {
  if (action.payload) {
    yield put(setInProgressOrdersNotFound(getStatus(action.payload)));
  }
}

export function* fetchEstimateByIdErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const estimateId = getFirstEstimateId(action);
  if (estimateId) {
    yield put(setEstimateDataStatus({ estimateId, status: getStatus(action.payload) }));
  }
}

export function* fetchFulltextSearchErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVehicleKey(action);
  const searchStatus = yield* select((state: RootState) => getSearchStatus(state));
  const searchId = getFirstSearchId(action);
  if (searchId && searchStatus?.searchId === searchId) {
    yield put(
      setSearchStatus({
        searchId,
        vehicleKey,
        searchText: searchStatus.searchText,
        status: getStatus(action.payload),
        source: 'DATAHUB',
        type: 'FULLTEXT',
        iamSearchScope: undefined,
      }),
    );
  }
}

export function* fetchIAMFulltextSearchErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVehicleKey(action);
  const searchStatus = yield* select((state: RootState) => getSearchStatus(state));
  const searchId = getFirstSearchId(action);
  if (searchId && searchStatus?.searchId === searchId) {
    yield put(
      setSearchStatus({
        searchId,
        vehicleKey,
        searchText: searchStatus.searchText,
        status: NOT_FOUND,
        source: 'IAM',
        type: 'FULLTEXT',
        iamSearchScope: undefined,
      }),
    );
  }
}

export function* fetchIAMEquivalentReferencesErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const searchStatus = yield* select((state: RootState) => getSearchStatus(state));
  const searchId = getFirstSearchId(action);
  if (searchId && searchStatus?.searchId === searchId) {
    yield put(setIAMFulltextEquivalentNoData(getStatus(action.payload)));
  }
}

export function* fetchIAMReferenceApplicabilityErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const reference = getFirstReference(action);
  if (reference) {
    yield put(setReferenceApplicabilitiesNoDataStatus({ reference, status: getStatus(action.payload) }));
  }
}

export function* fetchAutocompleteFulltextSearchErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVehicleKey(action);
  const searchText = getFirstSearchText(action);
  if (vehicleKey && searchText) {
    yield put(setFulltextAutocompleteNoData({ vehicleKey, searchText, status: getStatus(action.payload) }));
  }
}

export function* fetchSingleVehicleReferenceErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVehicleKey(action);
  const reference = getFirstReference(action);
  if (reference) {
    yield put(setDHSingleReferenceStatus({ reference, vehicleKey, status: getStatus(action.payload) }));
  }
}

export function* fetchPlatesForReferenceError(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVehicleKey(action) ?? '';
  const reference = getFirstReference(action);
  if (reference) {
    yield put(setPlatesForReferenceSearchStatus({ reference, vehicleKey, status: getStatus(action.payload) }));
  }
}

export function* fetchReferenceTextSearchErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVehicleKey(action);
  const reference = getFirstReference(action);
  const searchId = getFirstSearchId(action);
  if (reference) {
    yield put(setDHSingleReferenceStatus({ reference, vehicleKey, status: getStatus(action.payload) }));
  }
  const searchStatus = yield* select((state: RootState) => getSearchStatus(state));
  if (!searchId || searchStatus?.searchId !== searchId) {
    return;
  }
  yield put(
    setSearchStatus({
      searchId,
      vehicleKey,
      searchText: searchStatus.searchText,
      status: getStatus(action.payload),
      source: 'DATAHUB',
      type: 'REFERENCE',
      iamSearchScope: undefined,
    }),
  );
}

export function* fetchSearchVehicleBrandsErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  if (action.payload) {
    yield put(setVehicleBrandsNoDataStatus(getStatus(action.payload)));
  }
}

export function* fetchSearchVehicleEnginesErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const brandCode = getFirstBrand(action);
  const modelCode = getFirstModel(action);
  const modelTypeCode = getFirstModelType(action);

  if (brandCode && modelCode && modelTypeCode) {
    yield put(
      setVehicleEnginesNoDataStatus({ brandCode, modelCode, modelTypeCode, status: getStatus(action.payload) }),
    );
  }
}

export function* fetchIAMVehicleBrandsErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  yield put(setIAMVehicleBrandsNoDataStatus(getStatus(action.payload)));
}

export function* fetchIAMVehicleModelsErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const brandCode = getFirstBrand(action);
  if (brandCode) {
    yield put(setIAMVehicleModelsNoDataStatus({ brandCode, status: getStatus(action.payload) }));
  }
}

export function* fetchIAMVehicleVersionsErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const modelCode = getFirstModel(action);
  if (modelCode) {
    yield put(setIAMVehicleVersionsNoDataStatus({ modelCode, status: getStatus(action.payload) }));
  }
}

export function* fetchVehicleSearchHistoryErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  if (action.payload) {
    yield put(setVehicleSearchHistoryStatus(getStatus(action.payload)));
  }
}

export function* fetchUniversalProductsTreeErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  if (action.payload) {
    yield put(setUniversalProductsTree(getStatus(action.payload)));
  }
}

export function* fetchUniversalProductsErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const referenceNumbers = getAllDocumentsId(action);
  if (referenceNumbers && referenceNumbers.length > 0) {
    yield put(setUniversalProductsNoDataState({ referenceNumbers, status: getStatus(action.payload) }));
  }
}

export function* fetchUniversalProductsPagedErrorSaga(): SagaIterator {
  yield put(resetUniversalProductsPaged());
}

export function* fetchUniversalProductsSearchErrorSaga(): SagaIterator {
  yield put(resetUniversalProductsPaged());
}

export function* fetchUniversalProductsDataErrorSaga(): SagaIterator {
  yield put(resetUniversalProductsPaged());
}

export function* getPossibleBuyersForSellerErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  if (action.payload) {
    yield put(
      setPossibleBuyersForSellerToDelegateNoData({
        sellerId: getFirstSellerId(action) ?? 'missing dealer',
        status: getStatus(action.payload),
      }),
    );
  }
}

export function* getDelegationSellerErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  if (action.payload) {
    yield put(setPossibleSellersToDelegateNoData(getStatus(action.payload)));
    const sellerId = getFirstSellerId(action);
    yield call(notifyTop, 'error', 'Unable to delegate', sellerId ? `SELLER_ID: ${sellerId}` : null);
  }
}

export function* fetchUserSellersErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  yield call(notifyTop, 'error', AppTranslation.t('seller.error', 'Seller information unavailable.'), null);
  if (action.payload) {
    yield put(setUserSellersToChoose(getStatus(action.payload)));
  }
}

export function* fetchDHLaborTimesErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVehicleKey(action);
  const ids = getLaborTimeIds(action);
  if (vehicleKey && ids) {
    yield put(setLaborTimesSearchStatus({ vehicleKey, ids, status: getStatus(action.payload) }));
  }
}

export function* fetchIAMLaborTimesErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVehicleKey(action);
  const nodeId = getFirstNodeId(action);
  if (vehicleKey && nodeId) {
    yield put(setIAMLaborTimeNoDataStatus({ vehicleKey, nodeId, status: getStatus(action.payload) }));
  }
}

export function* fetchEstimateHistorySearchErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  yield put(setEstimateHistorySearchStatus(getStatus(action.payload)));
}

export function* fetchGarageInfoErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const garageId = getFirstGarageId(action);
  if (garageId) {
    yield put(setGarageNoDataStatus({ garageId, status: getStatus(action.payload) }));
  }
}

export function* fetchEstimateSettingsErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  yield put(setSettings(getStatus(action.payload)));
}

export function* fetchUploadFileElectronicPartsRepairFileStructureErrorSaga(
  action: WsResponse<BusinessError>,
): SagaIterator {
  yield put(setElectronicPartsRepairFileModalStatus(NO_FILE));
  yield put(setElectronicPartsRepairFileModalStatus(FILE_STRUCTURE_ERROR));
  yield put(setElectronicPartsRepairFileIsModalOpen(true));
  yield put(setElectronicPartsRepairSearchStatus(getStatus(action.payload)));
}

export function* fetchReplaceFileElectronicPartsRepairErrorSaga(): SagaIterator {
  yield put(setElectronicPartsRepairFileUploadStatus(SAME_FILE));
}

export function* fetchFileElectricPartsRepairErrorSaga(action: WsResponse): SagaIterator {
  const status = yield* select(getElectronicPartsRepairFileUploadStatus);

  if (status === REPLACING_FILE) {
    yield call(notifyTop, 'error', 'No response from the API. Something went wrong...', action.payload.message);
    yield put(setElectronicPartsRepairFileUploadStatus(API_CALL_ERROR));
    return;
  }
  yield put(setElectronicPartsRepairFileUploadStatus(NO_FILE));
}

export function* uploadFileCrossSellingErrorSaga(action: WsResponse): SagaIterator {
  const { status } = action.payload;
  switch (status) {
    case 'ERROR_EMPTY_FILE':
      yield put(setCrossSellingFileModalStatus(EMPTY_FILE_ERROR));
      return;
    case 'ERROR_FILE_STRUCTURE':
      yield put(setCrossSellingFileModalStatus(FILE_STRUCTURE_ERROR));
      return;
  }
  yield put(setElectronicPartsRepairFileUploadStatus(NO_FILE));
}

export function* deleteFileCrossSellingErrorSaga(): SagaIterator {
  yield put(setCrossSellingFileModalStatus(TECHNICAL_ERROR));
}

export function* fetchFileCrossSellingErrorSaga(action: WsResponse): SagaIterator {
  const status = yield* select(getCrossSellingFileUploadStatus);

  if (status === REPLACING_FILE) {
    yield call(notifyTop, 'error', 'No response from the API. Something went wrong...', action.payload.message);
    yield put(setCrossSellingFileUploadStatus(API_CALL_ERROR));
    return;
  }
  yield put(setCrossSellingSearchFileStatus(NOT_FOUND));
  yield put(setCrossSellingFileUploadStatus(NO_FILE));
}

export function* replaceFileCrossSellingErrorSaga(): SagaIterator {
  yield put(setCrossSellingFileModalStatus(SAME_FILE_ERROR));
  yield put(setCrossSellingFileUploadStatus(FILE));
}

export function* fetchCrossSellingFileReferencesErrorSaga(): SagaIterator {
  const vehicleKey = yield* select(getLastSearchedVehicleKey);
  yield put(setResolveCrossSellingReferencesStatus({ vehicleKey, status: NOT_FOUND }));
}

export function* fetchCrossSellingReferencesErrorSaga(): SagaIterator {
  const vehicleKey = yield* select(getLastSearchedVehicleKey);
  yield put(setResolveCrossSellingReferencesStatus({ vehicleKey, status: NOT_FOUND }));
}

export function* uploadDiscontinuedReferencesFileErrorSaga(action: WsResponse): SagaIterator {
  const { status } = action.payload;
  switch (status) {
    case 'ERROR_EMPTY_FILE':
      yield put(setDiscontinuedReferencesFileModalStatus(EMPTY_FILE_ERROR));
      yield put(setDiscontinuedReferencesFileUploadStatus(NO_FILE));
      yield call(
        notifyTop,
        'error',
        AppTranslation.t('common.file_upload.error.empty_file_error', 'Your uploaded file is empty'),
        null,
      );
      return;
    case 'ERROR_SAME_FILE':
      yield put(setDiscontinuedReferencesFileModalStatus(SAME_FILE_ERROR));
      yield put(setDiscontinuedReferencesFileUploadStatus(SAME_FILE));
      yield call(
        notifyTop,
        'error',
        AppTranslation.t('common.file_upload.error.same_file_error', 'This file is already published'),
        null,
      );
      return;
  }
}

export function* uploadBamCommercialFamilyCodesFileErrorSaga(action: WsResponse): SagaIterator {
  const { status } = action.payload;
  switch (status) {
    case 'ERROR_EMPTY_FILE':
      yield put(setBamCommercialFamilyCodesFileModalStatus(EMPTY_FILE_ERROR));
      yield put(setBamCommercialFamilyCodesFileUploadStatus(NO_FILE));
      yield call(
        notifyTop,
        'error',
        AppTranslation.t('common.file_upload.error.empty_file_error', 'Your uploaded file is empty'),
        null,
      );
      return;
    case 'ERROR_SAME_FILE':
      yield put(setBamCommercialFamilyCodesFileModalStatus(SAME_FILE_ERROR));
      yield put(setBamCommercialFamilyCodesFileUploadStatus(SAME_FILE));
      yield call(
        notifyTop,
        'error',
        AppTranslation.t('common.file_upload.error.same_file_error', 'This file is already published'),
        null,
      );
      return;
  }
}

export function* fetchIAMReferencesErrorSaga(action: WsResponse): SagaIterator {
  const vehicleKey = getFirstVehicleKey(action);
  const nodeId = getFirstNodeId(action);
  const provider = getFirstProvider(action);

  if (nodeId && vehicleKey) {
    yield put(setNodeIAMReferencesStatus({ nodeId, vehicleKey, provider, loadingState: NOT_FOUND }));
  }
}

export function* fetchExternalOrdersErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  yield put(setExternalOrdersNoDataStatus(getStatus(action.payload)));
}

export function* fetchPromotionErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const id = getFirstPromotionId(action);
  if (id) {
    yield put(setPromotionDetailDataStatus({ id, status: getStatus(action.payload) }));
  }
}

export function* fetchCurrentPromotionsErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  yield put(setCurrentPromotionsDataStatus({ status: getStatus(action.payload) }));
}

export function* fetchFullPromotionErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const id = getFirstPromotionId(action);
  if (id) {
    yield put(setFullPromotionState({ id, status: getStatus(action.payload) }));
  }
}

export function* fetchPromotionPublishErrorSaga(action: WsResponse<{ id: string }>): SagaIterator {
  const { id } = action.payload;
  if (id) {
    yield put(setPublishedPromotionStatus({ id, status: ERROR }));
  }
}

export function* fetchPromotionBannersErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  yield put(setPromotionBannersStatus(getStatus(action.payload)));
}

export function* handleInformationBannersErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  yield put(setInformationBanners(getStatus(action.payload)));
}

export function* fetchBackofficePromotionUploadReferencesErrorSaga(
  action: WsResponse<PromotionReferencesFileUploadResponse>,
): SagaIterator {
  yield call(
    notifyTop,
    'error',
    AppTranslation.t('common.file_upload.error', 'Upload error'),
    AppTranslation.t('common.file_upload.error.wrong_format_structure', 'File has wrong structure'),
  );
  yield put(removeUploadedReferencesRows({ fileId: action.payload.fileId }));
}

export function* fetchBackofficePromotionUploadTargetedAudienceErrorSaga(): SagaIterator {
  yield call(
    notifyTop,
    'error',
    AppTranslation.t('common.file_upload.error', 'Upload error'),
    AppTranslation.t('common.file_upload.error.wrong_format_structure', 'File has wrong structure'),
  );
  yield put(removeUploadedTargetedAudienceRows());
}

export function* fetchPictureErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const key = getFirstPictureKey(action);
  if (key) {
    yield put(setPictureNoDataStatus({ key, status: getStatus(action.payload) }));
  }
}

export function* fetchExplodedTreeError(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVehicleKey(action);
  if (vehicleKey) {
    yield put(setExplodedTreeNoDataStatus({ vehicleKey, status: getStatus(action.payload) }));
  }
}

export function* fetchIAMExplodedTreeError(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVehicleKey(action);
  const provider = getFirstProvider(action) as Provider;
  if (vehicleKey) {
    yield put(setExplodedTreeNoDataStatus({ vehicleKey, status: getStatus(action.payload), provider }));
  }
}

export function* fetchInformationErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const id = getFirstInformationId(action);
  if (id) {
    yield put(setInformationStatus({ id, status: getStatus(action.payload) }));
  }
}

export function* fetchInformationsErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const searchStatus = getStatus(action.payload);
  const statusType = getInformationsStatus(action) as StatusType;
  if (statusType) {
    yield put(setLoadedInformationsSearchStatus({ statusType, searchStatus }));
  }
}

export function* fetchSaveInformationErrorSaga(): SagaIterator {
  yield call(
    notifyTop,
    'error',
    AppTranslation.t('backoffice.save.error', 'Save error'),
    AppTranslation.t('backoffice.information.save.error', 'The information has not been saved.'),
  );
}

export function* fetchPublishInformationErrorSaga(): SagaIterator {
  yield call(
    notifyTop,
    'error',
    AppTranslation.t('backoffice.publish.error', 'Publish error'),
    AppTranslation.t('backoffice.information.publish.error', 'The publication of information was not successful.'),
  );
}

export function* fetchSaveInformationTemplateErrorSaga(): SagaIterator {
  yield call(
    notifyTop,
    'error',
    AppTranslation.t('backoffice.save.error', 'Save error'),
    AppTranslation.t('backoffice.information_template.save.error', 'The information template has not been saved.'),
  );
}

export function* fetchCentralSettingsErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  yield put(setCentralSettingsStatus(getStatus(action.payload)));
  yield call(
    notifyTop,
    'error',
    AppTranslation.t('backoffice.central-settings.loading.error', 'Failed to load central settings'),
  );
}

export function* fetchTechnicalCriteriaErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVehicleKey(action);
  if (vehicleKey) {
    yield put(setVehicleTechnicalCriteriaNoDataStatus({ vehicleKey, status: getStatus(action.payload) }));
  }
}

export function* fetchTechnicalDataTreeErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVehicleKey(action);
  const vehicleCode = getFirstIAMVehicleCode(action);
  if (vehicleKey && vehicleCode) {
    yield put(setVehicleTechnicalDataTreeNoDataStatus({ vehicleKey, vehicleCode, status: getStatus(action.payload) }));
  }
}

// TODO BE needs to properly send error from streamingQuery, currently responds only to send req timeout
export function* fetchTechnicalDataDetailsErrorSaga(
  action: WsResponse<{ vehicleKey: string; vehicleCode: string; categoryIds: string[] }>,
): SagaIterator {
  const { vehicleKey, vehicleCode, categoryIds } = action.payload;
  if (!vehicleKey || !vehicleCode || !categoryIds) return;

  // categoryIds are mainGroupIds; resolve the corresponding subGroupIds from the tree
  const subGroupIds: string[] = yield* select((state: RootState) => {
    const vehicle = state.catalog.vehicles.get(vehicleKey);
    const techDataLocal = getData(vehicle?.technicalData?.get(vehicleCode));
    if (!techDataLocal) {
      return categoryIds;
    }
    const resolved = categoryIds.flatMap(
      (mainGroupId) =>
        techDataLocal.technicalDataTree.find((mg) => mg.id === mainGroupId)?.subGroups.map((sg) => sg.id) ?? [],
    );
    return resolved.length > 0 ? resolved : categoryIds;
  });

  yield put(
    setVehicleTechnicalDataDetailsNoDataStatus({
      vehicleKey,
      vehicleCode,
      l3Ids: subGroupIds,
      status: ERROR,
    }),
  );
}

export function* fetchLevel3ErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVehicleKey(action);
  const lv3s = getAllMultiPlateIds(action);

  if (vehicleKey && lv3s) {
    yield put(setLevels3DetailNoDataStatus({ lv3s, vehicleKey, status: getStatus(action.payload) }));
  }
}

export function* fetchMaintenancePlanErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVIN(action);
  if (vehicleKey) {
    yield put(
      setMaintenancePlanStatus({
        vehicleKey,
        status: getStatus(action.payload),
      }),
    );
  }
}

export function* fetchMaintenanceValuesErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVehicleKey(action);
  if (vehicleKey) {
    yield put(
      setMaintenanceValuesStatus({
        status: getStatus(action.payload),
      }),
    );
  }
}

export function* fetchIAMServiceOperationsErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVIN(action);
  if (vehicleKey) {
    yield put(
      setServiceOperationsStatus({
        vehicleKey,
        versionCode: undefined,
        status: getStatus(action.payload),
      }),
    );
  }
}

export function* fetchIAMServiceProposalsErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVIN(action);
  if (vehicleKey) {
    yield put(
      setServiceProposalsStatus({
        vehicleKey,
        versionCode: undefined,
        status: getStatus(action.payload),
      }),
    );
  }
}

export function* fetchIAMServiceProposalOperationsErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVIN(action);
  if (vehicleKey) {
    yield put(
      setServiceProposalOperationsStatus({
        vehicleKey,
        versionCode: undefined,
        status: getStatus(action.payload),
      }),
    );
  }
}

export function* fetchIAMRepairMethodsErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVehicleKey(action);
  const nodeId = getFirstNodeId(action);
  if (vehicleKey && nodeId) {
    yield put(
      setIAMRepairMethodsNoDataStatus({
        vehicleKey,
        nodeId,
        status: getStatus(action.payload),
      }),
    );
  }
}

export function* emailGenericErrorSaga(): SagaIterator {
  yield call(notifyTop, 'error', AppTranslation.t('email.send.error', 'Email not sent'), null);
}

function* sendEmailToAssistanceErrorSaga(): SagaIterator {
  yield put(setEmailToAssistanceDataStatus(ERROR));
}

export function* sendEmailReturnRequestErrorSaga(): SagaIterator {
  yield put(setReturnRequestStatus(ERROR));
}

export function* tireProductsSearchErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const searchParamsBase64 = getTireSearchStatus(action);
  if (searchParamsBase64 !== undefined) {
    yield put(setTireSearchStatus({ searchParamsBase64, status: getStatus(action.payload) }));
  }
}

export function* vehicleTiresErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVehicleKey(action);
  if (!vehicleKey) return;
  yield put(setVehicleTiresStatus({ vehicleKey, status: getStatus(action.payload) }));
}

export function* fetchIAMTiresErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleCode = getFirstIAMVehicleCode(action);
  if (!vehicleCode) return;
  yield put(setIAMTiresNoDataStatus({ vehicleCode, status: getStatus(action.payload) }));
}

export function* fetchTireBrandCategoriesErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  yield put(setTireBrandCategoriesSearchStatus({ searchStatus: getStatus(action.payload) }));
}

export function* fetchGetTireBrandCategoriesErrorSaga(): SagaIterator {
  yield put(setTireBrandCategoriesSearchStatus({ searchStatus: ERROR }));
}

export function* fetchReuseStocksErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const referenceNumbers = getAllReferences(action);
  if (!referenceNumbers || referenceNumbers.length < 1) return;
  yield put(setReuseStockNoDataStatus({ referenceNumbers, status: getStatus(action.payload) }));
}

export function* fetchReuseAvailabilitiesErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const referenceNumbers = getAllReferences(action);
  if (!referenceNumbers || referenceNumbers.length < 1) return;
  yield put(setReuseAvailabilitiesNoDataStatus({ referenceNumbers, status: getStatus(action.payload) }));
}

export function* availableDMSServicesErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const message = getDMSErrorMessage(action);
  yield put(setAvailableDMSServicesStatus({ status: getStatus(action.payload), message }));
}

export function* repairOrderErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const errorCode = getDMSErrorCode(action);
  const errorType = getDMSErrorType(action) as DmsErrorType | undefined;
  const errorMessage = getDMSErrorMessage(action);

  yield put(setDMSErrors({ errorCode, errorType, errorMessage }));
}

export function* sendEstimateToDMSErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const errorCode = getSecondDMSErrorCode(action);
  const errorType = getSecondDMSErrorType(action) as DmsErrorType | undefined;
  const errorMessage = getSecondDMSErrorMessage(action);

  yield put(setDMSErrors({ errorCode, errorType, errorMessage }));
}

export function* fetchUploadOrderListReferencesTechnicalErrorSaga(): SagaIterator {
  yield put(setCreateOrderListSearchStatus({ searchStatus: FOUND }));
  yield call(
    notifyTop,
    'error',
    AppTranslation.t(
      'order_list.add_to_cart.error.technical',
      'The order list upload failed due to technical error.',
    ) as string,
    null,
  );
}

export function* fetchUploadOrderListReferencesExternalApiCallErrorSaga(): SagaIterator {
  yield put(setCreateOrderListSearchStatus({ searchStatus: FOUND }));
  yield call(
    notifyTop,
    'error',
    AppTranslation.t(
      'order_list.add_to_cart.error.api_call',
      'The order list upload failed due to external api call.',
    ) as string,
    null,
  );
}

export function* fetchUploadOrderListReferencesResponseNotReceivedErrorSaga(): SagaIterator {
  yield put(setCreateOrderListSearchStatus({ searchStatus: ERROR }));
}

export function* getBundlesErrorSaga(): SagaIterator {
  yield put(setBundlesStatus(ERROR));
}

export function* getMyStoreReferencesErrorSaga(): SagaIterator {
  yield put(setReferencesStatus(ERROR));
}

export function* getMyStoreErrorSaga(): SagaIterator {
  yield put(setMyStoreTiresSearchStatus(ERROR));
}

export function* fetchMprValidationErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const referenceNumbers = getAllReferences(action);
  if (!referenceNumbers || referenceNumbers.length < 1) return;
  for (const reference of referenceNumbers) {
    yield put(setMprValidationStatus({ reference, status: ERROR }));
  }
}

export function* fetchFileUploadOrderListReferences99ReferencesErrorSaga(): SagaIterator {
  yield put(setOrderListFileModalStatus(CONTENT_LIMIT_ERROR));
}

export function* fetchFileUploadOrderListReferencesFileErrorSaga(): SagaIterator {
  yield put(setOrderListFileModalStatus(FILE_STRUCTURE_ERROR));
}

export function* fetchOTSInformationErrorSaga(): SagaIterator {
  yield call(notifyTop, 'error', AppTranslation.t('ots.get.error', 'OTS information unavailable'), null);
}

export function* fetchClaimDocumentDownloadUrlErrorSaga(
  action: WsResponse<GetClaimAttachmentDownloadUrlResponse>,
): SagaIterator {
  yield put(clearOrderClaimAttachmentDownloading(action.payload.key));
  yield call(
    notifyTop,
    'error',
    AppTranslation.t('common.file_download.error', 'File download failed'),
    'Unable to download file.',
  );
}

export function* sendClaimErrorSaga(): SagaIterator {
  yield call(notifyTop, 'error', AppTranslation.t('order.claim.not_created', 'Claim not created'));
  yield put(setOrderClaimStatus(undefined));
}

export function* getGarageClaimErrorSaga(): SagaIterator {
  yield put(setLoadedClaimsSearchStatus(ERROR));
}

export function* subscribeSap2bClaimMessagesErrorResponse(): SagaIterator {
  yield call(notifyTop, 'error', AppTranslation.t('order.claim.not_created', 'Claim not created'));
  yield put(setOrderClaimStatus(undefined));
}

// if no R1Network was found, automatically set dealer pickup to true, otherwise take the manually set value
export function* subscribeR1NetworkErrorSaga(): SagaIterator {
  yield put(
    setClientConfig({
      searchStatus: FOUND,
      data: {
        isDealerPickupEnabled: true,
      },
    }),
  );
}

export function* sendIAMRepairMethodDetailErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const nodeId = getFirstNodeId(action);
  if (nodeId) {
    yield put(setRepairMethodDetailsStatus({ categoryId: nodeId, status: getStatus(action.payload) }));
  }
}

export function* fetchIAMRepairMethodsTreeErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const vehicleKey = getFirstVehicleKey(action);
  if (vehicleKey) {
    yield put(setIAMRepairMethodsTreeNoDataStatus({ vehicleKey, status: getStatus(action.payload) }));
  }
}

export function* fetchOrderByIdErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const orderId = getFirstOrderNumber(action);
  if (orderId) {
    yield put(setInProgressOrderSearchStatus({ orderId, status: getStatus(action.payload) }));
  }
}

export function* fetchBundlesAutocompleteFulltextSearchErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const searchCode = getFirstSearchText(action);
  const searchDesignation = getFirstSearchDescription(action);
  if (searchCode || searchDesignation) {
    yield put(
      setBundleFulltextAutocompleteNoData({
        searchCode: searchCode ?? '',
        searchDesignation: searchDesignation ?? '',
        status: getStatus(action.payload),
      }),
    );
  }
}

export function* fetchB2BEstimateReferencePriceErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const estimateId = getFirstEstimateId(action);
  const buyerTresorCode = getFirstBuyer(action);
  const sellerTresorCode = getFirstSeller(action);
  const referenceNumbers = getAllReferences(action);

  if (estimateId && buyerTresorCode && sellerTresorCode && referenceNumbers) {
    yield put(
      setB2BEstimateReferencesPriceNoDataStatus({
        estimateId,
        buyerTresorCode,
        sellerTresorCode,
        referenceNumbers,
        status: getStatus(action.payload),
      }),
    );
  }
}

export function* fetchB2BEstimateReferenceStockErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const estimateId = getFirstEstimateId(action);
  const buyerTresorCode = getFirstBuyer(action);
  const sellerTresorCode = getFirstSeller(action);
  const referenceNumbers = getAllReferences(action);

  if (estimateId && buyerTresorCode && sellerTresorCode && referenceNumbers) {
    yield put(
      setB2BEstimateReferencesStockNoDataStatus({
        estimateId,
        buyerTresorCode,
        sellerTresorCode,
        referenceNumbers,
        status: getStatus(action.payload),
      }),
    );
  }
}

export function* sendB2BEstimateToClientErrorSaga(): SagaIterator {
  yield call(
    notifyTop,
    'error',
    AppTranslation.t(
      'estimate.actions.result.estimate_sent_to_history_error',
      'Estimate has not been saved on client side',
    ),
    null,
  );
}

export function* fetchAscOrdersErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const { errorType } = action.payload;
  yield put(setAscOrdersStatus(errorType === 'NOT_FOUND' ? NOT_FOUND : ERROR));
}

export function* fetchMyClientsOrdersErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const { errorType } = action.payload;
  const type = errorType === 'NOT_FOUND' ? NOT_FOUND : ERROR;
  yield put(resetMyClientsOrders(type));
  if (type === ERROR) {
    yield call(notifyTop, 'error', AppTranslation.t('clients_order.load.error.title', 'Failed to load clients orders'));
  }
}

export function* fetchMyClientsOrderDetailErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const { errorType } = action.payload;
  yield put(setMyClientsOrderDetailStatus(errorType === 'NOT_FOUND' ? NOT_FOUND : ERROR));
}

export function* fetchIsDiscontinuedReferenceErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const reference = getFirstReference(action);
  if (!reference) {
    return;
  }
  yield put(setDiscontinuedReferenceSearchStatus({ reference, status: NOT_FOUND }));
}

export function* fetchEasyBasketOperationsErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const operationsIds = getAllOperationIds(action);
  if (operationsIds) {
    yield put(setOperationsStatus({ operationsIds, searchStatus: getStatus(action.payload) }));
  }
}

export function* fetchEasyBasketOperationDetailsErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const operationsIds = getAllOperationIds(action);
  if (operationsIds) {
    yield put(setOperationsDetailsStatus({ operationsIds, searchStatus: getStatus(action.payload) }));
  }
}

export function* sendGetReference3dModelErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const reference = getFirstReference(action);
  if (!reference) {
    return;
  }
  yield put(setReference3dModelSearchStatus({ reference, status: NOT_FOUND }));
}

export function* fetchMyNetworkClientsErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const { errorType } = action.payload;
  const type = errorType === 'NOT_FOUND' ? NOT_FOUND : ERROR;
  yield put(resetMyNetworkClients(type));
  if (type === ERROR) {
    yield call(notifyTop, 'error', AppTranslation.t('my_network.clients.load.error.title', 'Failed to load clients'));
  }
}

export function* fetchExadisReturnListErrorSaga(action: WsResponse<BusinessError>): SagaIterator {
  const { errorType } = action.payload;
  const type = errorType === 'NOT_FOUND' ? NOT_FOUND : ERROR;
  yield put(setExadisReturnList({ searchStatus: type, data: undefined }));
  if (type === ERROR) {
    yield call(
      notifyTop,
      'error',
      AppTranslation.t('exadis_return_list.load.error.title', 'Failed to load return list'),
    );
  }
}

export function* addExadisReturnListItemErrorSaga(_action: WsResponse<BusinessError>): SagaIterator {
  yield put(setExadisReturnListAddItemStatus(ERROR));
  yield call(
    notifyTop,
    'error',
    AppTranslation.t('exadis_return_list.add_item.error.title', 'Failed to add item to return list'),
  );
}

export function* updateMyNetworkClientsErrorSaga(): SagaIterator {
  yield put(setMyNetworkClientsSubmitting(false));
  yield call(
    notifyTop,
    'error',
    AppTranslation.t('my_network.garage_details.save.error.title', 'Failed to save client profile'),
    AppTranslation.t(
      'my_network.garage_details.save.error.description',
      'Application failed to save the clients profile. Please try again later.',
    ),
  );
}

export function* addEasyBasketToEstimateErrorSaga(action: WsResponse<string>): SagaIterator {
  const estimateId = action.payload;
  yield put(setEasyBasketEstimateCreationStatus({ estimateId, status: ERROR }));
  yield call(
    notifyTop,
    'error',
    AppTranslation.t('catalog.easy_basket.action.generate_estimate.error', 'Failed to add EasyBasket to estimate'),
  );
}

export function* ErrorsSagas(): SagaIterator {
  yield takeEvery(actions.getPossibleBuyersForSellerErrorSaga.type, sagaGuard(getPossibleBuyersForSellerErrorSaga));
  yield takeEvery(actions.getPossibleSellersForUserErrorSaga.type, sagaGuard(getDelegationSellerErrorSaga));
  yield takeEvery(actions.getDelegationSellerErrorSaga.type, sagaGuard(getDelegationSellerErrorSaga));
  yield takeEvery(actions.fetchUserSellersErrorSaga.type, sagaGuard(fetchUserSellersErrorSaga));
  yield takeEvery(actions.fetchSearchVehicleErrorSaga.type, sagaGuard(fetchSearchVehicleErrorSaga));
  yield takeEvery(actions.fetchVehicleInfoByVrnErrorSaga.type, sagaGuard(fetchVehicleInfoByVrnErrorSaga));
  yield takeEvery(actions.fetchPlateReferencesErrorSaga.type, sagaGuard(fetchPlateReferencesErrorSaga));
  yield takeEvery(actions.fetchMarketingReferencesErrorSaga.type, sagaGuard(fetchMarketingReferencesErrorSaga));
  yield takeEvery(actions.fetchReferencesStocksErrorSaga.type, sagaGuard(fetchReferencesStocksErrorSaga));
  yield takeEvery(actions.fetchDmsReferencesStocksErrorSaga.type, sagaGuard(fetchDmsReferencesStocksErrorSaga));
  yield takeEvery(actions.fetchReferencesStocksTimeoutErrorSaga.type, sagaGuard(fetchReferencesStocksTimeoutErrorSaga));
  yield takeEvery(actions.fetchReferencesPriceErrorSaga.type, sagaGuard(fetchReferencesPriceErrorSaga));
  yield takeEvery(actions.uploadFileCrossSellingErrorSaga.type, sagaGuard(uploadFileCrossSellingErrorSaga));
  yield takeEvery(actions.deleteFileCrossSellingErrorSaga.type, sagaGuard(deleteFileCrossSellingErrorSaga));
  yield takeEvery(
    actions.fetchCrossSellingFileReferencesErrorSaga.type,
    sagaGuard(fetchCrossSellingFileReferencesErrorSaga),
  );
  yield takeEvery(actions.fetchCrossSellingReferencesErrorSaga.type, sagaGuard(fetchCrossSellingReferencesErrorSaga));
  yield takeEvery(
    actions.uploadDiscontinuedReferencesFileErrorSaga.type,
    sagaGuard(uploadDiscontinuedReferencesFileErrorSaga),
  );
  yield takeEvery(
    actions.uploadBamCommercialFamilyCodesFileErrorSaga.type,
    sagaGuard(uploadBamCommercialFamilyCodesFileErrorSaga),
  );
  yield takeEvery(
    actions.fetchLaborTimeIdsByGenericPartErrorSaga.type,
    sagaGuard(fetchLaborTimeIdsByGenericPartErrorSaga),
  );
  yield takeEvery(actions.fetchReferencesRepairPriceErrorSaga.type, sagaGuard(fetchReferencesRepairPriceErrorSaga));
  yield takeEvery(actions.fetchBasketErrorSaga.type, sagaGuard(fetchBasketErrorSaga));
  yield takeEvery(
    actions.fetchAddEstimateKnownLaborTimeErrorSaga.type,
    sagaGuard(fetchAddEstimateKnownLaborTimeErrorSaga),
  );
  yield takeEvery(
    actions.fetchUploadFileReferences99ReferencesErrorSaga.type,
    sagaGuard(fetchUploadFileReferences99ReferencesErrorSaga),
  );
  yield takeEvery(
    actions.fetchUploadFileReferencesTechnicalErrorSaga.type,
    sagaGuard(fetchUploadFileReferencesTechnicalErrorSaga),
  );
  yield takeEvery(
    actions.fetchUploadFileReferencesApiCallErrorSaga.type,
    sagaGuard(fetchUploadFileReferencesApiCallErrorSaga),
  );
  yield takeEvery(actions.fetchDealerOrderListSaga.type, sagaGuard(fetchDealerOrderListSaga));
  yield takeEvery(actions.fetchOrderByIdErrorSaga.type, sagaGuard(fetchOrderByIdErrorSaga));
  yield takeEvery(actions.fetchEstimateByIdErrorSaga.type, sagaGuard(fetchEstimateByIdErrorSaga));
  yield takeEvery(
    actions.fetchB2BEstimateReferenceStockErrorSaga.type,
    sagaGuard(fetchB2BEstimateReferenceStockErrorSaga),
  );
  yield takeEvery(
    actions.fetchB2BEstimateReferencePriceErrorSaga.type,
    sagaGuard(fetchB2BEstimateReferencePriceErrorSaga),
  );
  yield takeEvery(actions.sendB2BEstimateToClientErrorSaga.type, sagaGuard(sendB2BEstimateToClientErrorSaga));
  yield takeEvery(actions.fetchFulltextSearchErrorSaga.type, sagaGuard(fetchFulltextSearchErrorSaga));
  yield takeEvery(actions.fetchIAMFulltextSearchErrorSaga.type, sagaGuard(fetchIAMFulltextSearchErrorSaga));
  yield takeEvery(actions.fetchIAMEquivalentReferencesErrorSaga.type, sagaGuard(fetchIAMEquivalentReferencesErrorSaga));
  yield takeEvery(
    actions.fetchAutocompleteFulltextSearchErrorSaga.type,
    sagaGuard(fetchAutocompleteFulltextSearchErrorSaga),
  );
  yield takeEvery(actions.fetchSingleVehicleReferenceErrorSaga.type, sagaGuard(fetchSingleVehicleReferenceErrorSaga));
  yield takeEvery(actions.fetchPlatesForReferenceError.type, sagaGuard(fetchPlatesForReferenceError));
  yield takeEvery(actions.fetchReferenceTextSearchErrorSaga.type, sagaGuard(fetchReferenceTextSearchErrorSaga));
  yield takeEvery(actions.fetchSearchVehicleBrandsErrorSaga.type, sagaGuard(fetchSearchVehicleBrandsErrorSaga));
  yield takeEvery(actions.fetchSearchVehicleEnginesErrorSaga.type, sagaGuard(fetchSearchVehicleEnginesErrorSaga));
  yield takeEvery(actions.fetchIAMVehicleBrandsErrorSaga.type, sagaGuard(fetchIAMVehicleBrandsErrorSaga));
  yield takeEvery(actions.fetchIAMVehicleModelsErrorSaga.type, sagaGuard(fetchIAMVehicleModelsErrorSaga));
  yield takeEvery(actions.fetchIAMVehicleVersionsErrorSaga.type, sagaGuard(fetchIAMVehicleVersionsErrorSaga));
  yield takeEvery(actions.fetchVehicleSearchHistoryErrorSaga.type, sagaGuard(fetchVehicleSearchHistoryErrorSaga));
  yield takeEvery(actions.fetchUniversalProductsTreeErrorSaga.type, sagaGuard(fetchUniversalProductsTreeErrorSaga));
  yield takeEvery(actions.fetchUniversalProductsErrorSaga.type, sagaGuard(fetchUniversalProductsErrorSaga));
  yield takeEvery(actions.fetchUniversalProductsPagedErrorSaga.type, sagaGuard(fetchUniversalProductsPagedErrorSaga));
  yield takeEvery(actions.fetchUniversalProductsSearchErrorSaga.type, sagaGuard(fetchUniversalProductsSearchErrorSaga));
  yield takeEvery(actions.fetchUniversalProductsDataErrorSaga.type, sagaGuard(fetchUniversalProductsDataErrorSaga));
  yield takeEvery(actions.fetchDHLaborTimesErrorSaga.type, sagaGuard(fetchDHLaborTimesErrorSaga));
  yield takeEvery(actions.fetchIAMLaborTimesErrorSaga.type, sagaGuard(fetchIAMLaborTimesErrorSaga));
  yield takeEvery(actions.fetchEstimateHistorySearchErrorSaga.type, sagaGuard(fetchEstimateHistorySearchErrorSaga));
  yield takeEvery(actions.fetchGarageInfoErrorSaga.type, sagaGuard(fetchGarageInfoErrorSaga));
  yield takeEvery(actions.fetchEstimateSettingsErrorSaga.type, sagaGuard(fetchEstimateSettingsErrorSaga));
  yield takeEvery(
    actions.fetchUploadFileElectronicPartsRepairFileStructureErrorSaga.type,
    sagaGuard(fetchUploadFileElectronicPartsRepairFileStructureErrorSaga),
  );
  yield takeEvery(
    actions.fetchReplaceFileElectronicPartsRepairErrorSaga.type,
    sagaGuard(fetchReplaceFileElectronicPartsRepairErrorSaga),
  );
  yield takeEvery(actions.fetchFileElectricPartsRepairErrorSaga.type, sagaGuard(fetchFileElectricPartsRepairErrorSaga));
  yield takeEvery(actions.fetchFileCrossSellingErrorSaga.type, sagaGuard(fetchFileCrossSellingErrorSaga));
  yield takeEvery(actions.replaceFileCrossSellingErrorSaga.type, sagaGuard(replaceFileCrossSellingErrorSaga));
  yield takeEvery(actions.fetchIAMReferencesErrorSaga.type, sagaGuard(fetchIAMReferencesErrorSaga));
  yield takeEvery(actions.fetchExternalOrdersErrorSaga.type, sagaGuard(fetchExternalOrdersErrorSaga));

  // Promotion
  yield takeEvery(actions.fetchPromotionErrorSaga.type, sagaGuard(fetchPromotionErrorSaga));
  yield takeEvery(actions.fetchCurrentPromotionsErrorSaga.type, sagaGuard(fetchCurrentPromotionsErrorSaga));
  yield takeEvery(actions.fetchFullPromotionErrorSaga.type, sagaGuard(fetchFullPromotionErrorSaga));
  yield takeEvery(actions.fetchPromotionPublishErrorSaga.type, sagaGuard(fetchPromotionPublishErrorSaga));
  yield takeEvery(actions.fetchPromotionBannersErrorSaga.type, sagaGuard(fetchPromotionBannersErrorSaga));
  yield takeEvery(
    actions.fetchBackofficePromotionUploadReferencesErrorSaga.type,
    sagaGuard(fetchBackofficePromotionUploadReferencesErrorSaga),
  );
  yield takeEvery(
    actions.fetchBackofficePromotionUploadTargetedAudienceErrorSaga.type,
    sagaGuard(fetchBackofficePromotionUploadTargetedAudienceErrorSaga),
  );
  yield takeEvery(actions.fetchPictureErrorSaga.type, sagaGuard(fetchPictureErrorSaga));
  yield takeEvery(actions.fetchExplodedTreeError.type, sagaGuard(fetchExplodedTreeError));
  yield takeEvery(actions.fetchIAMExplodedTreeError.type, sagaGuard(fetchIAMExplodedTreeError));

  // Information
  yield takeEvery(actions.fetchInformationErrorSaga.type, sagaGuard(fetchInformationErrorSaga));
  yield takeEvery(actions.handleInformationBannersErrorSaga.type, sagaGuard(handleInformationBannersErrorSaga));
  yield takeEvery(actions.fetchInformationsErrorSaga.type, sagaGuard(fetchInformationsErrorSaga));
  yield takeEvery(actions.fetchSaveInformationErrorSaga.type, sagaGuard(fetchSaveInformationErrorSaga));
  yield takeEvery(actions.fetchPublishInformationErrorSaga.type, sagaGuard(fetchPublishInformationErrorSaga));
  yield takeEvery(actions.fetchSaveInformationTemplateErrorSaga.type, sagaGuard(fetchSaveInformationTemplateErrorSaga));

  // Central Settings
  yield takeEvery(actions.fetchCentralSettingsErrorSaga.type, sagaGuard(fetchCentralSettingsErrorSaga));

  yield takeEvery(actions.fetchTechnicalCriteriaErrorSaga.type, sagaGuard(fetchTechnicalCriteriaErrorSaga));
  yield takeEvery(actions.fetchTechnicalDataTreeErrorSaga.type, sagaGuard(fetchTechnicalDataTreeErrorSaga));
  yield takeEvery(actions.fetchTechnicalDataDetailsErrorSaga.type, sagaGuard(fetchTechnicalDataDetailsErrorSaga));
  yield takeEvery(actions.fetchLevel3ErrorSaga.type, sagaGuard(fetchLevel3ErrorSaga));

  //Maintenance  plan
  yield takeEvery(actions.fetchMaintenancePlanErrorSaga.type, sagaGuard(fetchMaintenancePlanErrorSaga));
  yield takeEvery(actions.fetchIAMServiceOperationsErrorSaga.type, sagaGuard(fetchIAMServiceOperationsErrorSaga));
  yield takeEvery(actions.fetchIAMServiceProposalsErrorSaga.type, sagaGuard(fetchIAMServiceProposalsErrorSaga));
  yield takeEvery(
    actions.fetchIAMServiceProposalOperationsErrorSaga.type,
    sagaGuard(fetchIAMServiceProposalOperationsErrorSaga),
  );
  yield takeEvery(actions.fetchMaintenanceValuesErrorSaga.type, sagaGuard(fetchMaintenanceValuesErrorSaga));

  // emails
  yield takeEvery(actions.sendEmailFromGarageErrorSaga.type, sagaGuard(emailGenericErrorSaga));
  yield takeEvery(actions.sendEmailToAssistanceErrorSaga.type, sagaGuard(sendEmailToAssistanceErrorSaga));
  yield takeEvery(actions.sendEmailReturnRequestErrorSaga.type, sagaGuard(sendEmailReturnRequestErrorSaga));

  //tires
  yield takeEvery(actions.tireProductsSearchErrorSaga.type, sagaGuard(tireProductsSearchErrorSaga));
  yield takeEvery(actions.vehicleTiresErrorSaga.type, sagaGuard(vehicleTiresErrorSaga));
  yield takeEvery(actions.availableDMSServicesErrorSaga.type, sagaGuard(availableDMSServicesErrorSaga));
  yield takeEvery(actions.repairOrderErrorSaga.type, sagaGuard(repairOrderErrorSaga));
  yield takeEvery(actions.getBundlesErrorSaga.type, sagaGuard(getBundlesErrorSaga));
  yield takeEvery(actions.getMyStoreTiresErrorSaga.type, sagaGuard(getMyStoreErrorSaga));
  yield takeEvery(actions.getMyStoreReferencesErrorSaga.type, sagaGuard(getMyStoreReferencesErrorSaga));

  yield takeEvery(actions.sendEstimateToDMSErrorSaga.type, sagaGuard(sendEstimateToDMSErrorSaga));
  yield takeEvery(actions.fetchIAMTiresErrorSaga.type, sagaGuard(fetchIAMTiresErrorSaga));
  yield takeEvery(actions.fetchTireBrandCategoriesErrorSaga.type, sagaGuard(fetchTireBrandCategoriesErrorSaga));
  yield takeEvery(actions.fetchGetTireBrandCategoriesErrorSaga.type, sagaGuard(fetchGetTireBrandCategoriesErrorSaga));
  yield takeEvery(actions.fetchReuseStocksErrorSaga.type, sagaGuard(fetchReuseStocksErrorSaga));
  yield takeEvery(actions.fetchReuseAvailabilitiesErrorSaga.type, sagaGuard(fetchReuseAvailabilitiesErrorSaga));
  yield takeEvery(actions.fetchMprValidationErrorSaga.type, sagaGuard(fetchMprValidationErrorSaga));
  yield takeEvery(
    actions.fetchUploadOrderListReferencesTechnicalErrorSaga.type,
    sagaGuard(fetchUploadOrderListReferencesTechnicalErrorSaga),
  );
  yield takeEvery(
    actions.fetchUploadOrderListReferencesApiCallErrorSaga.type,
    sagaGuard(fetchUploadOrderListReferencesExternalApiCallErrorSaga),
  );
  yield takeEvery(
    actions.fetchUploadOrderListReferencesResponseNotReceivedErrorSaga.type,
    sagaGuard(fetchUploadOrderListReferencesResponseNotReceivedErrorSaga),
  );
  yield takeEvery(
    actions.fetchFileUploadOrderListReferences99ReferencesErrorSaga.type,
    sagaGuard(fetchFileUploadOrderListReferences99ReferencesErrorSaga),
  );
  yield takeEvery(
    actions.fetchFileUploadOrderListReferencesFileErrorSaga.type,
    sagaGuard(fetchFileUploadOrderListReferencesFileErrorSaga),
  );
  yield takeEvery(actions.fetchIAMRepairMethodsErrorSaga.type, sagaGuard(fetchIAMRepairMethodsErrorSaga));
  yield takeEvery(actions.fetchOTSInformationErrorSaga.type, sagaGuard(fetchOTSInformationErrorSaga));
  yield takeEvery(actions.sendIAMRepairMethodDetailErrorSaga.type, sagaGuard(sendIAMRepairMethodDetailErrorSaga));
  yield takeEvery(actions.fetchIAMRepairMethodsTreeErrorSaga.type, sagaGuard(fetchIAMRepairMethodsTreeErrorSaga));
  yield takeEvery(
    actions.fetchBundlesAutocompleteFulltextSearchErrorSaga.type,
    sagaGuard(fetchBundlesAutocompleteFulltextSearchErrorSaga),
  );
  yield takeEvery(
    actions.fetchClaimDocumentDownloadUrlErrorSaga.type,
    sagaGuard(fetchClaimDocumentDownloadUrlErrorSaga),
  );
  yield takeEvery(actions.sendClaimErrorSaga.type, sagaGuard(sendClaimErrorSaga));
  yield takeEvery(actions.getGarageClaimErrorSaga.type, sagaGuard(getGarageClaimErrorSaga));
  yield takeEvery(
    actions.subscribeSap2bClaimMessagesErrorResponse.type,
    sagaGuard(subscribeSap2bClaimMessagesErrorResponse),
  );
  yield takeEvery(actions.fetchIsDiscontinuedReferenceErrorSaga.type, sagaGuard(fetchIsDiscontinuedReferenceErrorSaga));
  yield takeEvery(actions.subscribeR1NetworkErrorSaga.type, sagaGuard(subscribeR1NetworkErrorSaga));
  yield takeEvery(actions.fetchAscOrdersErrorSaga.type, sagaGuard(fetchAscOrdersErrorSaga));
  yield takeEvery(
    actions.fetchIAMReferenceApplicabilityErrorSaga.type,
    sagaGuard(fetchIAMReferenceApplicabilityErrorSaga),
  );
  yield takeEvery(actions.fetchEasyBasketOperationsErrorSaga.type, sagaGuard(fetchEasyBasketOperationsErrorSaga));
  yield takeEvery(
    actions.fetchEasyBasketOperationDetailsErrorSaga.type,
    sagaGuard(fetchEasyBasketOperationDetailsErrorSaga),
  );
  yield takeEvery(actions.sendGetReference3dModelErrorSaga.type, sagaGuard(sendGetReference3dModelErrorSaga));
  yield takeEvery(actions.fetchMyClientsOrdersErrorSaga.type, sagaGuard(fetchMyClientsOrdersErrorSaga));
  yield takeEvery(actions.fetchMyClientsOrderDetailErrorSaga.type, sagaGuard(fetchMyClientsOrderDetailErrorSaga));
  yield takeEvery(actions.fetchMyNetworkClientsErrorSaga.type, sagaGuard(fetchMyNetworkClientsErrorSaga));
  yield takeEvery(actions.fetchExadisReturnListErrorSaga.type, sagaGuard(fetchExadisReturnListErrorSaga));
  yield takeEvery(actions.addExadisReturnListItemErrorSaga.type, sagaGuard(addExadisReturnListItemErrorSaga));
  yield takeEvery(actions.updateMyNetworkClientsErrorSaga.type, sagaGuard(updateMyNetworkClientsErrorSaga));
  yield takeEvery(actions.addEasyBasketToEstimateErrorSaga.type, sagaGuard(addEasyBasketToEstimateErrorSaga));
}
